
import { makeAutoObservable, runInAction } from 'mobx';
import { request } from '@src/common';
import { HelpOther } from '@/common/helper';
import InviteFormModal from './index';
import userStore from '@/store/user';
import { INVITE_STATUS_WAIT, INVITE_STATUS_WAITTING, INVITE_STATUS_SUCCESS, INVITE_STATUS_ACTIVE, INVITE_STATUS_FAIL, INVITE_FORM_DATA} from './constant'


const defaultFormData = {
  mobile: '',
  user_need: '',
  job: '',
  email: '',
  social_media: '',
}

class Store {
  constructor() {
    makeAutoObservable(this);
  }
  // 提交过的表单数据
  submitedData = null;
  // 表单数据
  formData = null;
  // 表单状态
  inviteStatus = INVITE_STATUS_WAIT;
  // 按钮文案
  inviteBtnText = '';

  init = () => {
    this.getHistorySubmitData();
  }

  /** 提交申请 */
  submit = (data) => {
    request({
      url: '/ai_agent/invite/apply',
      method: 'post',
      data
    }).then((res) => {
      HelpOther.toast('提交成功', 'success');
      InviteFormModal.close();
    }).catch((e) => {
      HelpOther.toast(e.msg, 'error');
    });
  }

  /** 获取历史提交数据 */
  getHistorySubmitData = () => {
    request({
      url: '/ai_agent/invite/status',
      method: 'get'
    }).then((res) => {
      runInAction(() => {
        this.inviteStatus = res.data.status;
        this.submitedData = res.data;
      });
    });
  }

  /** 绑定手机号 */
  bindMobile = () => {
    userStore.showBindMobile(() => {
      userStore.requestUserInfo();
    });
  }
}

export default new Store();